import AssemblyGameScreen from './scenes/AssemblyGameScreen';
import IntroScreen from './scenes/IntroScreen';
import LabelGameScreen from './scenes/LabelGameScreen';

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [IntroScreen, LabelGameScreen, AssemblyGameScreen],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: IntroScreen.KEY,
  LABEL_BEST_SCORE: Number.MAX_SAFE_INTEGER,
  ASSEMBLY_BEST_SCORE: Number.MAX_SAFE_INTEGER,
};

export const DEFAULT_BUTTON_CONFIG = { pressAnimationConfig: { scale: 0.8 }, releaseAnimationConfig: { scale: 1 } };